import { StyleSheet } from 'aphrodite';
import { header } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		padding: 16,
	},
	surveyDetailsContainer: {
		marginBottom: 24,
	},
	surveyTitle: {
		fontSize: 24,
		fontWeight: 600,
		marginBottom: 16,
	},
	surveyDescription: {
		fontSize: 16,
		lineHeight: '1.5',
		color: header,
	},
});
